module.exports = __webpack_public_path__ + "static/media/background.2d1d130a.jpg";